/**
 * auditSeedLogs.ts — Logs demo de Auditoría (seed compartido).
 *
 * QUÉ HACE: Exporta los logs de ejemplo que se siembran cuando la clave de
 *   auditoría está vacía. Cubren las secciones del feed de Actividad del
 *   Dashboard (Caja, Ventas, Cierres, Movimientos, Créditos, Fidelización,
 *   Inventario, Personal, Higiene) con fechas relativas a «ahora» para que
 *   aparezcan como actividad del día.
 * QUÉ INVOCA: Solo tipos (Log de auditoría). Sin UI ni almacenamiento.
 * QUÉ EXPORTA: AUDIT_SEED_LOGS (Log[]).
 * QUÉ NO DEBE HACER: No leer/escribir almacenamiento ni depender de React.
 */

import type { Log } from "../types/auditoria.types";

export const AUDIT_SEED_LOGS: Log[] = [
  {
    id: "AUD-SEED-1",
    userId: "usuario_1",
    userName: "Juan Pérez",
    action: "caja_venta_completada",
    entidad: "ventas",
    entidadId: "V-45812",
    resumen: "Venta #V-45812 completada por $84.500",
    descripcion:
      "Venta completada en efectivo: 2x Gafas de Sol Unisex, 1x Cinturón Hombre Cuero.",
    severity: "low",
    createdAt: new Date(Date.now() - 2 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    userAgent:
      "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/149.0.0.0 Safari/537.36",
    endpoint: "/api/auditoria/ventas",
    details: {
      monto: 84500,
      metodoPago: "Efectivo",
      puntoCajaId: "pc_principal",
      sesionId: "sesion_1783442613022",
    },
    cambios: [],
    isViewed: false,
  },
  {
    id: "AUD-SEED-2",
    userId: "usuario_3",
    userName: "María Rodríguez",
    action: "higiene_registro_guardado",
    entidad: "higiene",
    entidadId: "area_bano_clientes",
    resumen: "Registro de limpieza: Baño clientes",
    descripcion:
      "Se guardó el registro de limpieza del área Baño clientes con evidencia fotográfica.",
    severity: "low",
    createdAt: new Date(Date.now() - 6 * 60_000).toISOString(),
    ipAddress: "192.168.1.42",
    endpoint: "/api/auditoria/higiene",
    details: { area: "Baño clientes", responsable: "María Rodríguez" },
    cambios: [
      {
        campo: "Estado de limpieza",
        antes: "Pendiente",
        despues: "Completada",
        detalles: "Registro con evidencia",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-3",
    userId: "usuario_2",
    userName: "Sofía Martínez",
    action: "caja_venta_completada",
    entidad: "ventas",
    entidadId: "V-45813",
    resumen: "Venta #V-45813 completada por $132.800",
    descripcion:
      "Venta completada con tarjeta: 1x Tennis Urbanos, 1x Media Azul Marítimo.",
    severity: "low",
    createdAt: new Date(Date.now() - 9 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/ventas",
    details: {
      monto: 132800,
      metodoPago: "Tarjeta",
      puntoCajaId: "pc_principal",
      sesionId: "sesion_1783442613022",
    },
    cambios: [],
    isViewed: false,
  },
  {
    id: "AUD-SEED-4",
    userId: "sistema",
    userName: "Sistema",
    action: "inventario_stock_agotado",
    entidad: "inventario",
    entidadId: "prod_agua_1",
    resumen: "Stock agotado: Agua Cristal 600ml",
    descripcion:
      "El producto Agua Cristal 600ml llegó a stock 0 tras la última venta.",
    severity: "high",
    createdAt: new Date(Date.now() - 14 * 60_000).toISOString(),
    ipAddress: "192.168.1.1",
    endpoint: "/api/auditoria/inventario",
    details: {
      producto: "Agua Cristal 600ml",
      stockAnterior: 2,
      stockActual: 0,
    },
    cambios: [
      {
        campo: "Stock: Agua Cristal 600ml",
        antes: 2,
        despues: 0,
        detalles: "Agotado tras venta",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-5",
    userId: "usuario_4",
    userName: "Carlos Gómez",
    action: "personal_asistencia_entrada",
    entidad: "personal_asistencia",
    entidadId: "asis_45812",
    resumen: "Check-in: Carlos Gómez (08:00)",
    descripcion: "Registro de entrada del empleado Carlos Gómez a las 08:00.",
    severity: "low",
    createdAt: new Date(Date.now() - 18 * 60_000).toISOString(),
    ipAddress: "192.168.1.30",
    endpoint: "/api/auditoria/personal",
    details: { empleado: "Carlos Gómez", hora: "08:00", tipo: "Entrada" },
    cambios: [
      {
        campo: "Asistencia",
        antes: "Sin marcar",
        despues: "Entrada 08:00",
        detalles: "Check-in en punto de venta",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-6",
    userId: "usuario_1",
    userName: "Juan Pérez",
    action: "caja_descuento_aplicado",
    entidad: "margenes",
    entidadId: "V-45811",
    resumen: "Descuento global de $12.500 aplicado a la venta",
    descripcion:
      "Se aplicó un descuento global de $12.500 (10%) sobre la venta #V-45811.",
    severity: "low",
    createdAt: new Date(Date.now() - 22 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/ajuste",
    details: { monto: 12500, totalVenta: 125000 },
    cambios: [
      {
        campo: "Total Factura",
        antes: 137500,
        despues: 125000,
        detalles: "Descuento global aplicado",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-7",
    userId: "usuario_2",
    userName: "Sofía Martínez",
    action: "credito_abono_registrado",
    entidad: "creditos",
    entidadId: "cred_1002",
    resumen: "Abono de $50.000 al crédito de Daniel Rojas",
    descripcion:
      "Abono registrado al crédito #CR-1002 de Daniel Rojas. Saldo restante: $120.000.",
    severity: "low",
    createdAt: new Date(Date.now() - 28 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/creditos",
    details: { monto: 50000, saldoRestante: 120000, cliente: "Daniel Rojas" },
    cambios: [
      {
        campo: "Saldo del crédito",
        antes: 170000,
        despues: 120000,
        detalles: "Abono registrado",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-8",
    userId: "admin_01",
    userName: "Admin Sistema",
    action: "caja_punto_creado",
    entidad: "terminales",
    entidadId: "pc_secundario",
    resumen: "Punto de caja 'POS Secundario' creado",
    descripcion:
      "Se creó el punto de caja POS Secundario con impresora térmica asociada.",
    severity: "low",
    createdAt: new Date(Date.now() - 35 * 60_000).toISOString(),
    ipAddress: "192.168.1.10",
    endpoint: "/api/auditoria/terminales",
    details: { puntoCaja: "POS Secundario", impresora: "Térmica 80mm" },
    cambios: [
      {
        campo: "Puntos de caja",
        antes: "1 punto",
        despues: "2 puntos",
        detalles: "Nuevo punto POS",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-9",
    userId: "usuario_3",
    userName: "María Rodríguez",
    action: "personal_tarea_completada",
    entidad: "personal_tareas",
    entidadId: "tarea_2210",
    resumen: "Tarea 'Inventario de vitrina' completada",
    descripcion:
      "La tarea 'Inventario de vitrina' fue marcada como completada por María Rodríguez.",
    severity: "low",
    createdAt: new Date(Date.now() - 42 * 60_000).toISOString(),
    ipAddress: "192.168.1.42",
    endpoint: "/api/auditoria/personal",
    details: { tarea: "Inventario de vitrina", estado: "Completada" },
    cambios: [
      {
        campo: "Estado de tarea",
        antes: "En progreso",
        despues: "Completada",
        detalles: "Tarea finalizada",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-10",
    userId: "admin_01",
    userName: "Admin Sistema",
    action: "fidelizacion_premio_creado",
    entidad: "fidelizacion",
    entidadId: "premio_7",
    resumen: "Premio 'Descuento 20%' creado",
    descripcion:
      "Se creó el premio de fidelización 'Descuento 20% en tu próxima compra' (800 pts).",
    severity: "low",
    createdAt: new Date(Date.now() - 48 * 60_000).toISOString(),
    ipAddress: "192.168.1.10",
    endpoint: "/api/auditoria/fidelizacion",
    details: { premio: "Descuento 20%", puntos: 800 },
    cambios: [
      {
        campo: "Premios disponibles",
        antes: "4 premios",
        despues: "5 premios",
        detalles: "Nuevo premio creado",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-11",
    userId: "usuario_3",
    userName: "María Rodríguez",
    action: "higiene_area_creada",
    entidad: "higiene",
    entidadId: "area_cocina",
    resumen: "Área 'Cocina' creada",
    descripcion:
      "Se creó el área de higiene 'Cocina' con frecuencia de limpieza diaria.",
    severity: "low",
    createdAt: new Date(Date.now() - 55 * 60_000).toISOString(),
    ipAddress: "192.168.1.42",
    endpoint: "/api/auditoria/higiene",
    details: { area: "Cocina", frecuencia: "Diaria" },
    cambios: [
      {
        campo: "Áreas de higiene",
        antes: "3 áreas",
        despues: "4 áreas",
        detalles: "Nueva área creada",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-12",
    userId: "usuario_1",
    userName: "Juan Pérez",
    action: "facturacion_venta_anulada",
    entidad: "ventas",
    entidadId: "V-45789",
    resumen: "Venta #V-45789 anulada — $22.300",
    descripcion:
      "Se anuló la venta #V-45789 por error del cajero. Se devolvió el dinero en efectivo.",
    severity: "medium",
    createdAt: new Date(Date.now() - 65 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/facturacion",
    details: { monto: 22300, motivo: "Error del cajero" },
    cambios: [
      {
        campo: "Estado de venta",
        antes: "Completada",
        despues: "Anulada",
        detalles: "Anulación con devolución",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-13",
    userId: "usuario_2",
    userName: "Sofía Martínez",
    action: "caja_arqueo_iniciado",
    entidad: "turnos",
    entidadId: "turno_4581",
    resumen: "Arqueo de caja iniciado (turno mañana)",
    descripcion:
      "Sofía Martínez inició el arqueo de caja del turno mañana en POS Principal.",
    severity: "low",
    createdAt: new Date(Date.now() - 75 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/turnos",
    details: { turno: "Mañana", puntoCajaId: "pc_principal" },
    cambios: [],
    isViewed: false,
  },
  {
    id: "AUD-SEED-14",
    userId: "usuario_1",
    userName: "Juan Pérez",
    action: "caja_retiro_registrado",
    entidad: "tesoreria",
    entidadId: "MOV-90021",
    resumen: "Retiro de caja $200.000 — compra proveedor",
    descripcion:
      "Retiro de $200.000 de la caja principal para compra de mercancía al proveedor.",
    severity: "low",
    createdAt: new Date(Date.now() - 90 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/movimientos",
    details: { monto: 200000, motivo: "Compra proveedor" },
    cambios: [
      {
        campo: "Efectivo en caja",
        antes: 1450000,
        despues: 1250000,
        detalles: "Retiro registrado",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-15",
    userId: "usuario_3",
    userName: "María Rodríguez",
    action: "inventario_stock_repuesto",
    entidad: "inventario",
    entidadId: "prod_pan_2",
    resumen: "Stock repuesto: Pan Tajado 12",
    descripcion:
      "Se repuso el stock de Pan Tajado 12 tras la llegada del proveedor.",
    severity: "low",
    createdAt: new Date(Date.now() - 100 * 60_000).toISOString(),
    ipAddress: "192.168.1.42",
    endpoint: "/api/auditoria/inventario",
    details: { producto: "Pan Tajado 12", cantidad: 30 },
    cambios: [
      {
        campo: "Stock: Pan Tajado 12",
        antes: 4,
        despues: 34,
        detalles: "Reposición de proveedor",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-16",
    userId: "usuario_2",
    userName: "Sofía Martínez",
    action: "caja_cerrada",
    entidad: "turnos",
    entidadId: "turno_4581",
    resumen: "Cierre de caja turno mañana — diferencia de -$12.000",
    descripcion:
      "Cierre de caja del turno mañana con diferencia negativa de $12.000 respecto al arqueo.",
    severity: "high",
    createdAt: new Date(Date.now() - 120 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/turnos",
    details: { diferencia: -12000, puntoCajaId: "pc_principal" },
    cambios: [
      {
        campo: "Diferencia de caja",
        antes: 0,
        despues: -12000,
        detalles: "Faltante detectado en arqueo",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-17",
    userId: "admin_01",
    userName: "Admin Sistema",
    action: "fidelizacion_sorteo_realizado",
    entidad: "fidelizacion",
    entidadId: "sorteo_3",
    resumen: "Sorteo semanal de puntos realizado",
    descripcion:
      "Se realizó el sorteo semanal de puntos. Ganador: Laura Peña (2.500 pts).",
    severity: "medium",
    createdAt: new Date(Date.now() - 3 * 60 * 60_000).toISOString(),
    ipAddress: "192.168.1.10",
    endpoint: "/api/auditoria/fidelizacion",
    details: { ganador: "Laura Peña", puntos: 2500 },
    cambios: [
      {
        campo: "Sorteos",
        antes: "2 realizados",
        despues: "3 realizados",
        detalles: "Sorteo semanal ejecutado",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-18",
    userId: "admin_01",
    userName: "Admin Sistema",
    action: "personal_empleado_editado",
    entidad: "personal",
    entidadId: "emp_002",
    resumen: "Aumento salarial: María López (+$250.000)",
    descripcion:
      "Actualización de salario para María López: de $1.300.000 a $1.550.000 por promoción interna.",
    severity: "medium",
    createdAt: new Date(Date.now() - 4 * 60 * 60_000).toISOString(),
    ipAddress: "192.168.1.10",
    endpoint: "/api/auditoria/personal",
    details: {
      empleado: "María López",
      salarioAnterior: 1300000,
      salarioNuevo: 1550000,
    },
    cambios: [
      {
        campo: "Salario: María López",
        antes: 1300000,
        despues: 1550000,
        detalles: "Promoción interna",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-19",
    userId: "usuario_2",
    userName: "Sofía Martínez",
    action: "caja_venta_credito",
    entidad: "creditos",
    entidadId: "cred_1002",
    resumen: "Venta a crédito $120.000 — Daniel Rojas",
    descripcion:
      "Venta a crédito de $120.000 para Daniel Rojas con plazo a 15 días e interés del 2%.",
    severity: "medium",
    createdAt: new Date(Date.now() - 5 * 60 * 60_000).toISOString(),
    ipAddress: "192.168.1.45",
    endpoint: "/api/auditoria/creditos",
    details: { monto: 120000, cliente: "Daniel Rojas", plazo: "15 días" },
    cambios: [
      {
        campo: "Crédito del cliente",
        antes: 0,
        despues: 120000,
        detalles: "Venta a crédito registrada",
      },
    ],
    isViewed: false,
  },
  {
    id: "AUD-SEED-20",
    userId: "admin_01",
    userName: "Admin Sistema",
    action: "nomina_empleado_liquidado",
    entidad: "nomina",
    entidadId: "nom_782",
    resumen: "Nómina liquidada: periodo quincenal",
    descripcion:
      "Se liquidó la nómina quincenal del periodo actual: 8 empleados, total $18.400.000.",
    severity: "medium",
    createdAt: new Date(Date.now() - 6 * 60 * 60_000).toISOString(),
    ipAddress: "192.168.1.10",
    endpoint: "/api/auditoria/nomina",
    details: { empleados: 8, total: 18400000, periodo: "Quincenal" },
    cambios: [
      {
        campo: "Nóminas liquidadas",
        antes: "1 en el periodo",
        despues: "2 en el periodo",
        detalles: "Liquidación quincenal",
      },
    ],
    isViewed: false,
  },
];
